import request from '@/utils/request'
const baseUrl = '/sign-api'

// 用户登录
export async function login (data) {
  return request({
    url: `${baseUrl}/login`,
    method: 'post',
    data,
  })
}

// 用户登出
export async function logout () {
  return request({
    url: `${baseUrl}/logout`,
    method: 'post',
  })
}

// 获取验证码
export function getVerifyCode () {
  return request({
    url: `${baseUrl}/verifyCode`,
    method: 'get',
  })
}

// 查询用户信息
export function getUserInfo () {
  return request({
    url: `${baseUrl}/user`,
    method: 'get',
  })
}

// 个人银行卡四要素验证
export function livenessDetect (data) {
  return request({
    url: `${baseUrl}/user/certification/person/liveness-detect-h5`,
    method: 'post',
    data,
  })
}

// 个人活体检测-H5
export function checkBank (data) {
  return request({
    url: `${baseUrl}/user/certification/person/bank`,
    method: 'post',
    data,
  })
}

// 个人活体检测-检测结果查询
export function livenessDetectResult (sn) {
  return request({
    url: `${baseUrl}/user/certification/person/liveness-detect-feedresult?txSN=${sn}`,
    method: 'get',
  })
}


// 个人活体检测-自拍照有源对比
export function livenessDetectSc (data) {
  return request({
    url: `${baseUrl}/user/certification/person/liveness-detect-sc`,
    method: 'post',
    data,
  })
}

// 个人安心签注册
export function register (data) {
  return request({
    url: `${baseUrl}/user/certification/anxin-sign/person/signup`,
    method: 'post',
    data,
  })
}

// 企业安心签注册
export function enterpriseRegister (data) {
  return request({
    url: `${baseUrl}/user/certification/anxin-sign/enterprise/signup`,
    method: 'post',
    data,
  })
}

// 用户图章查询
export function getUserSeal () {
  return request({
    url: `${baseUrl}/user/seals`,
    method: 'get',
  })
}

// 获取用户图章图片
export function getUserSealImage (sealID) {
  return request({
    url: `${baseUrl}/user/seal/${sealID}`,
    method: 'get',
  })
}
// 获取用户图章图片
export function getUserSealImageSrc (sealID) {
  return `${baseUrl}/user/seal/${sealID}`;
}
// 修改用户图章
export function changeUserSealImage (sealID, data) {
  return request({
    url: `${baseUrl}/user/seal/${sealID}`,
    method: 'post',
    data,
  })
}

// 手写签名识别检测
export function recognition (data) {
  return request({
    url: `${baseUrl}/user/certification/seal-hw/recognition`,
    method: 'post',
    data,
  })
}


/**
* 查询购销合同（客户专属）
 * 签名验证手机号 String phoneNo;
 * 要签署的合同编码 String contractNo;
 * 合同的下载地址  String contractUrl;
 * 合同的名称 String contractName;
*
*/
export function getTradeAgreement (data = {}) {
  return request({
    url: `${baseUrl}/user/trade-agreement`,
    method: 'get',
    data,
  })
}
/**
 * 签约的合约地址路径， 查看，下载使用
 *  contractNo：  数据来源于getTradeAgreement（）接口
 */
export function getContractUrl (contractNo) {
  return `${baseUrl}/anxin-contract/${contractNo}/downloading`;
}

export function getBuffer (url) {
  return request({
    url,
    method: 'get',
    responseType: 'arraybuffer',
  })
}

export function getTradeInfo () {
  return getTradeAgreement().then(res => {
    const { contractNo } = res.data;
    const url = contractNo ? getContractUrl(contractNo) : ''
    return {
      ...res.data,
      contractUrl: url
    }
  })
}


/**
 * 签约合同
 * @returns
 */
export function agreementContract (smsCheckCode, contractNo) {
  return request({
    url: `${baseUrl}/user/axs-contract/${contractNo}/sign`,
    method: 'post',
    data: { "smsCheckCode": smsCheckCode },
  })
}

/**
 * 合同获得签名的手机验证码
 * @returns
 */
export function getContractNoCheckCode (contractNo) {
  return request({
    url: `${baseUrl}/user/anxin-sign/${contractNo}/sms-checkcode/`,
    method: 'post',
    data: { "contractNo": contractNo },
  })
}


